import type { DotTypes } from '../types'

export default {
  dots: 'dots',
  rounded: 'rounded',
  classy: 'classy',
  classyRounded: 'classy-rounded',
  square: 'square',
  extraRounded: 'extra-rounded'
} as DotTypes
